// extracted by mini-css-extract-plugin
module.exports = {"sampleText":"SiteModal_sampleText_2gqtZ","tooltip":"SiteModal_tooltip_2OiIW","spinAround":"SiteModal_spinAround_g6_-z"};